<script lang="ts" setup>
import { useGoogleAuth } from "~/composables/google/google-auth"
import { useTokenCookie } from "~/composables/local/token-cookie"
import { useRecaptcha } from "~/composables/recaptcha/recaptcha"

definePageMeta({
	layout: "empty",
	middleware: "is-not-logged",
})

useHead({
	title: "هوش مصنوعی Tuka | ورود به اپلیکیشن",
})

const notify = useNotification()
const token = useTokenCookie()
const api = useApi()
const recaptcha = useRecaptcha()
const phoneLoading = ref(false)
const codeLoading = ref(false)

const google = useGoogleAuth()
const route = useRoute()

onMounted(async () => {
	await Promise.all([
		recaptcha.initialize(),
		google.initialize(),
	])
})

async function onGoogleLogin() {
	google.signIn(false)
	if (route.query.subscriptionId) {
		const { data } = await api.subscription.buySubscription({
			subscriptionId: String(route.query.subscriptionId),
		})

		await navigateTo(data.url, { external: true })
	}
	else if (route.query.amount) {
		const { data } = await api.credit.buyCredit({
			amount: Number(route.query.amount),
		})

		await navigateTo(data.url, { external: true })
	}
	else {
		await navigateTo("/app")
	}
}

async function sendSms(phoneNumber: string) {
	phoneLoading.value = true
	try {
		const code = await recaptcha.getCode("loginViaSms")
		await api.user.loginViaSms({ phoneNumber }, { headers: { recaptcha: code } })

		notify.successText({ description: "کدی به شماره تلفن شما پیامک شد." })
	}
	catch (error: any) {
		if (error.status === 429)
			notify.errorText({ description: "کد ارسال شده است." })
	}
	phoneLoading.value = false
}

async function sendCode(code: string[], phoneNumber: string) {
	codeLoading.value = true
	const pin = code.join("")
	try {
		const { data } = await api.user.exchangePhoneOtp({
			code: pin,
			phoneNumber,
		})
		token.setCookie(data.token)
		if (route.query?.subscriptionId) {
			const { data } = await api.subscription.buySubscription({
				subscriptionId: String(route.query.subscriptionId),
			})

			navigateTo(data.url, { external: true })
		}
		else if (route.query.amount) {
			const { data } = await api.credit.buyCredit({
				amount: Number(route.query.amount),
			})

			await navigateTo(data.url, { external: true })
		}
		else {
			notify.successText({ description: "ورود با موفقیت انجام شد." })
			await navigateTo("/app")
		}
	}
	catch (error) {
		notify.errorObject(error as any)
	}
	codeLoading.value = false
}
</script>

<template>
	<div class="relative min-h-screen w-screen flex flex-col items-center justify-center overflow-hidden md:py-10">
		<NuxtImg
			src="/images/patterns/login.svg"
			class="fixed end-0 top-0 z-1 w-1200px translate-x--100px translate-y--200px select-none" />

		<div class="z-2 flex flex-col gap-y-6 md:mb-4">
			<div class="items-center justify-center hidden md:flex">
				<NuxtImg
					src="/website/big-logo.png"
					format="webp"
					fit="inside"
					width="122"
					height="80" />
			</div>

			<SelectWayLogin
				:phone-loading="phoneLoading"
				:code-loading="codeLoading"
				:google-loading="google.loading.value"
				@send-code="sendCode"
				@send-sms="sendSms"
				@google-login="onGoogleLogin" />
		</div>

		<div class="z-2 text-sm text-[#4D4F5C] hidden md:flex">
			بعد از ثبت نام، می تونی از اشتراک رایگان توکا، استفاده کنی !
		</div>
	</div>
</template>
